import axios from 'axios';
import { browserHistory } from 'react-router';

import {
  REQUEST_CUSTOMERS,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  REQUEST_CUSTOMERS_PAGINATE,
  FETCH_CUSTOMERS_PAGINATE_SUCCESS,
  FETCH_CUSTOMERS_PAGINATE_FAILURE,
  REQUEST_CUSTOMERS_STATUS,
  FETCH_CUSTOMERS_STATUS_SUCCESS,
  FETCH_CUSTOMERS_STATUS_FAILURE,
  SELECT_CUSTOMER,
  RESET_CURRENT_CUSTOMER,
  REQUEST_CREATING_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  REQUEST_EDITING_CUSTOMER,
  EDIT_CUSTOMER_SUCCESS,
  EDIT_CUSTOMER_FAILURE,
  REQUEST_CUSTOMER_DETAIL,
  FETCH_CUSTOMER_DETAIL_SUCCESS,
  FETCH_CUSTOMER_DETAIL_FAILURE,
  REQUEST_CUSTOMER_CREDIT_BY_DATE,
  FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS,
  FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE,
  ATTACH_DOCUMENT,
  ATTACH_DOCUMENT_SUCCESS,
  ATTACH_DOCUMENT_FAILURE,
} from './type';
import {
  CUSTOMERS_URL,
  CUSTOMERS_PAGINATE_URL,
  CUSTOMER_CREDIT_LINES_URL,
  CUSTOMERS_STATUS_URL,
  UPLOAD_URL,
  FETCH_FJ_AGENTS_URL,
  FETCH_PRICE_TABLE_URL,
  FETCH_PRICE_TABLE_URL_VENDOR,
} from './url';
import { ROOT_URL, ROOT_API_URL } from '../actions/root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isYI = ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || ROOT_URL === 'https://ying-scm.truckxi.com/api/';

export function requestCustomers() {
  return {
    type: REQUEST_CUSTOMERS,
  };
}

export function fetchCustomersSuccess(customers) {
  return {
    type: FETCH_CUSTOMERS_SUCCESS,
    payload: customers,
  };
}

export function fetchCustomersFailure(error) {
  return {
    type: FETCH_CUSTOMERS_FAILURE,
    payload: error,
  };
}

export function fetchCustomers(cb = () => {}) {
  return (dispatch) => {
    dispatch(requestCustomers());
    return axios.get(
      CUSTOMERS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomersSuccess(response));
        cb();
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomersFailure(err));
      });
  };
}

export function requestCustomersPaginate() {
  return {
    type: REQUEST_CUSTOMERS_PAGINATE,
  };
}

export function fetchCustomersPaginateSuccess(customers) {
  return {
    type: FETCH_CUSTOMERS_PAGINATE_SUCCESS,
    payload: customers,
  };
}

export function fetchCustomersPaginateFailure(error) {
  return {
    type: FETCH_CUSTOMERS_PAGINATE_FAILURE,
    payload: error,
  };
}

export function fetchCustomersPaginate(currentPage, limit, searchFilter) {
  if (!limit) { limit = 'all'; }
  currentPage = currentPage + 1;
  const url = `${CUSTOMERS_PAGINATE_URL}`;
  return (dispatch) => {
    dispatch(requestCustomersPaginate());
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        page: currentPage,
        limit: limit,
        CustomerNum: searchFilter.CustomerNum,
        Name: searchFilter.Name,
        Email: searchFilter.email,
        Description: searchFilter.Description,
        IsWholesale: searchFilter.IsWholesale,
        PriceLevel: searchFilter.PriceLevel,
        IsActive: searchFilter.IsActive,
        MemberCard: searchFilter.MemberCard,
        Reseller: searchFilter.Reseller,
        phone: searchFilter.Telephone,
        address: searchFilter.Street,
        City: searchFilter.City,
      },
    }).then((response) => {
        dispatch(fetchCustomersPaginateSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomersPaginateFailure(err));
      });
  };
}

export function fetchActiveCustomers() {
  return (dispatch) => {
    dispatch(requestCustomers());
    return axios({
      method: 'get',
      url: `${CUSTOMERS_URL}?Customer_id__IsActive=1`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(fetchCustomersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomersFailure(err));
      });
  };
}

export function selectCustomer(customer) {
  return {
    type: SELECT_CUSTOMER,
    payload: customer,
  };
}

export function resetCurrentCustomer() {
  return {
    type: RESET_CURRENT_CUSTOMER,
  };
}

// Actions to deal with the promise of posting function.
export function requestCreatingCustomer() {
  return {
    type: REQUEST_CREATING_CUSTOMER,
  };
}

export function createCustomerSuccess() {
  return {
    type: CREATE_CUSTOMER_SUCCESS,
  };
}

export function createCustomerFailure(error) {
  return {
    type: CREATE_CUSTOMER_FAILURE,
    payload: error,
  };
}

export function createCustomer({
  Billing,
  CreditLimit,
  CustomerNum,
  DeliverPlan_id,
  Description,
  email,
  IsActive,
  IsPrtGeneralInfor,
  IsPrtReminder,
  IsShowPrice,
  IsShippingFee,
  IsWholesale,
  Mailing,
  Name,
  Notation,
  PaymentTerm_id,
  StorageFeeType,
  PriceLevel,
  RefNum,
  Sales_User_id,
  Shipping,
  Wholesale_ResaleNo,
  FinanceEmail,
  OperationEmail,
  EIN,
  StorageFreeDays,
  FlatMarkup,
  PctMarkup,
  DLN,
  Reseller,
  MemberCard,
  DiscountPercentage,
  Route_id,
}, { businessType: BusinessType, creditStatus: CreditStatus, IsStripe, Sub_Customer_id }) {
  // if(ControlledMailingAddress) {
  //   MailingAddress = {...ControlledMailingAddress};
  // }
  // if(ControlledMailingContact) {
  //   MailingContact = {...ControlledMailingContact};
  // }
  // if(ShippingAddress && currentShippingAddress) {
  //   if(ShippingAddress[0] && currentShippingAddress) {
  //     ShippingAddress[0] = {...ShippingAddress[0], ...currentShippingAddress};
  //   }
  // }
  // if(ShippingContact && currentShippingContact) {
  //   if(ShippingContact[0] && currentShippingContact) {
  //     ShippingContact[0] = {...ShippingContact[0], currentShippingContact};
  //   }
  // }
  if (PaymentTerm_id) {
    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  }
  if (StorageFeeType) {
    StorageFeeType = StorageFeeType.value || StorageFeeType;
  }
  if (Sales_User_id) {
    Sales_User_id = Sales_User_id.value || Sales_User_id;
  }
  if (Shipping && Shipping.length > 0 && isMAG) {
    Shipping.map((r,index) => {
      if (r.DrayageCode && r.DrayageCode.value) {
        r.DrayageCode = r.DrayageCode.value;
      }
    });
  }

  let noBilling = false;
  if (isYI && (!Billing || Object.keys(Billing).length === 0)) {
    noBilling = true;
  }

  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_CUSTOMER });
    axios.post(
      CUSTOMERS_URL,
      noBilling ? {
        CustomerNum,
        RefNum,
        Name,
        Description,
        IsWholesale,
        IsShowPrice,
        IsShippingFee,
        CreditLimit,
        CreditStatus,
        PriceLevel,
        IsActive,
        DeliverPlan_id,
        IsPrtReminder,
        IsPrtGeneralInfor,
        Sales_User_id,
        PaymentTerm_id,
        StorageFeeType,
        Notation,
        Shipping,
        // Mailing,
        // Billing,
        email,
        BusinessType,
        IsStripe,
        Wholesale_ResaleNo,
        FinanceEmail,
        OperationEmail,
        EIN,
        StorageFreeDays,
        FlatMarkup,
        PctMarkup,
        DLN,
        Reseller,
        MemberCard,
        Sub_Customer_id,
        DiscountPercentage,
        Route_id,
      } : {
        CustomerNum,
        RefNum,
        Name,
        Description,
        IsWholesale,
        IsShowPrice,
        IsShippingFee,
        CreditLimit,
        CreditStatus,
        PriceLevel,
        IsActive,
        DeliverPlan_id,
        IsPrtReminder,
        IsPrtGeneralInfor,
        Sales_User_id,
        PaymentTerm_id,
        StorageFeeType,
        Notation,
        Shipping,
        Mailing,
        Billing,
        email,
        BusinessType,
        IsStripe,
        Wholesale_ResaleNo,
        FinanceEmail,
        OperationEmail,
        EIN,
        StorageFreeDays,
        FlatMarkup,
        PctMarkup,
        DLN,
        Reseller,
        MemberCard,
        Sub_Customer_id,
        DiscountPercentage,
        Route_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(createCustomerSuccess());
        browserHistory.push('/customers');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createCustomerFailure(err));
      });
  };
}

// Edit Customer
export function editCustomerSuccess() {
  return {
    type: EDIT_CUSTOMER_SUCCESS,
  };
}
export function editCustomerFailure(error) {
  return {
    type: EDIT_CUSTOMER_FAILURE,
    payload: error,
  };
}
export function editCustomer({
  Customer_id,
  CustomerNum,
  RefNum,
  Name,
  Description,
  IsWholesale,
  IsShowPrice,
  IsShippingFee,
  CreditLimit,
  PriceLevel,
  IsActive,
  DeliverPlan_id,
  IsPrtReminder,
  IsPrtGeneralInfor,
  Sales_User_id,
  PaymentTerm_id,
  StorageFeeType,
  Notation,
  Shipping,
  Mailing,
  Billing,
  email,
  Wholesale_ResaleNo,
  FinanceEmail,
  OperationEmail,
  EIN,
  StorageFreeDays,
  FlatMarkup,
  PctMarkup,
  DLN,
  Reseller,
  MemberCard,
  DiscountPercentage,
  Route_id,
}, { businessType: BusinessType, creditStatus: CreditStatus, IsStripe, Sub_Customer_id }) {
  // if(ControlledMailingAddress) {
  //   MailingAddress = {...ControlledMailingAddress};
  // }
  // if(ControlledMailingContact) {
  //   MailingContact = {...ControlledMailingContact};
  // }
  // if(ShippingAddress && currentShippingAddress) {
  //   if(ShippingAddress[0] && currentShippingAddress) {
  //     ShippingAddress[0] = {...ShippingAddress[0], ...currentShippingAddress};
  //   }
  // }
  // if(ShippingContact && currentShippingContact) {
  //   if(ShippingContact[0] && currentShippingContact) {
  //     ShippingContact[0] = currentShippingContact;
  //   }
  // }
  if (PaymentTerm_id) {
    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  }
  if (StorageFeeType) {
    StorageFeeType = StorageFeeType.value || StorageFeeType;
  }
  if (Sales_User_id) {
    Sales_User_id = Sales_User_id.value || Sales_User_id;
  }
  if (Shipping && Shipping.length > 0 && isMAG) {
    Shipping.map((r,index) => {
      if (r.DrayageCode && r.DrayageCode.value) {
        r.DrayageCode = r.DrayageCode.value;
      }
    });
  }

  let noBilling = false;
  if (isYI && (!Billing || Object.keys(Billing).length === 0)) {
    noBilling = true;
  }

  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_CUSTOMER });
    axios.put(
      (CUSTOMERS_URL + Customer_id),
      noBilling ? {
        CustomerNum,
        RefNum,
        Name,
        Description,
        IsWholesale,
        IsShowPrice,
        IsShippingFee,
        CreditLimit,
        CreditStatus,
        PriceLevel,
        IsActive,
        DeliverPlan_id,
        IsPrtReminder,
        IsPrtGeneralInfor,
        Sales_User_id,
        PaymentTerm_id,
        StorageFeeType,
        Notation,
        Shipping,
        // Mailing,
        // Billing,
        email,
        BusinessType,
        IsStripe,
        Wholesale_ResaleNo,
        FinanceEmail,
        OperationEmail,
        EIN,
        StorageFreeDays,
        FlatMarkup,
        PctMarkup,
        DLN,
        Reseller,
        MemberCard,
        Sub_Customer_id,
        DiscountPercentage,
        Route_id,
      } : {
        CustomerNum,
        RefNum,
        Name,
        Description,
        IsWholesale,
        IsShowPrice,
        IsShippingFee,
        CreditLimit,
        CreditStatus,
        PriceLevel,
        IsActive,
        DeliverPlan_id,
        IsPrtReminder,
        IsPrtGeneralInfor,
        Sales_User_id,
        PaymentTerm_id,
        StorageFeeType,
        Notation,
        Shipping,
        Mailing,
        Billing,
        email,
        BusinessType,
        IsStripe,
        Wholesale_ResaleNo,
        FinanceEmail,
        OperationEmail,
        EIN,
        StorageFreeDays,
        FlatMarkup,
        PctMarkup,
        DLN,
        Reseller,
        MemberCard,
        Sub_Customer_id,
        DiscountPercentage,
        Route_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editCustomerSuccess());
        browserHistory.push('/customers'); // If editd succesfully, refresh the paymentTerm page.
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editCustomerFailure(err));
      });
  };
}


export function editCustomerGroup({
  Customer_id,
  CustomerGroup_id,
}) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_CUSTOMER });
    axios.put(
      (CUSTOMERS_URL + Customer_id),
      {
        CustomerGroup_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editCustomerSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editCustomerFailure(err));
      });
  };
}

export function requestEditingCustomer() {
  return {
    type: REQUEST_EDITING_CUSTOMER,
  };
}

// Fetch the detail page.
export function requestCustomerDetail() {
  return {
    type: REQUEST_CUSTOMER_DETAIL,
  };
}
export function fetchCustomerDetailSuccess(customerDetail) {
  return {
    type: FETCH_CUSTOMER_DETAIL_SUCCESS,
    payload: customerDetail,
  };
}
export function fetchCustomerDetailFailure(error) {
  return {
    type: FETCH_CUSTOMER_DETAIL_FAILURE,
    payload: error,
  };
}
export function fetchCustomerDetail(customer_id) {
  return (dispatch) => {
    dispatch(requestCustomerDetail());
    return axios.get(
      CUSTOMERS_URL + customer_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerDetailFailure(err));
      });
  };
}

// fetch Customer Credit By Date
export function requestCustomerCreditByDate() {
  return {
    type: REQUEST_CUSTOMER_CREDIT_BY_DATE,
  };
}

export function fetchCustomerCreditByDateSuccess(customerDetail) {
  return {
    type: FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS,
    payload: customerDetail,
  };
}
export function fetchCustomerCreditByDateFailure(error) {
  return {
    type: FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE,
    payload: error,
  };
}
export function fetchCustomerCreditByDate(date) {
  return (dispatch) => {
    dispatch(requestCustomerCreditByDate());
    return axios.get(
      CUSTOMER_CREDIT_LINES_URL + date,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerCreditByDateSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerCreditByDateFailure(err));
      });
  };
}

// Fetch Customers Status
export function fetchCustomersStatusSuccess(statuses) {
  return {
    type: FETCH_CUSTOMERS_STATUS_SUCCESS,
    payload: statuses,
  };
}
export function fetchCustomersStatusFailure(error) {
  return {
    type: FETCH_CUSTOMERS_STATUS_FAILURE,
    payload: error,
  };
}
export function fetchCustomersStatus() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMERS_STATUS });
    return axios.get(
      CUSTOMERS_STATUS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomersStatusSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomersStatusFailure(err));
      });
  };
}

// Attach Document
export function attachDocumentSuccess() {
  return {
    type: ATTACH_DOCUMENT_SUCCESS,
  };
}
export function attachDocumentFailure(error) {
  return {
    type: ATTACH_DOCUMENT_FAILURE,
    payload: error,
  };
}
export function attachDocument(files) {
  return (dispatch) => {
    dispatch({ type: ATTACH_DOCUMENT });
    let data = new FormData();
    data.append('customer_file', files[0]);

    return axios.post(
      `${UPLOAD_URL}customer/`, data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(attachDocumentSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(attachDocumentFailure(err));
      });
  };
}

export function fetchFJAgents(customer) {
  const url = `${FETCH_FJ_AGENTS_URL}${customer}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function updateFJAgents(customer, agentsArray) {
  let output = [];
  agentsArray.map(r => {
    if (r.name) {
      output.push(r);
    }
  });
  // if (output.length === 0) {
  //   alert("Must have at least one valid agent name");
  //   return;
  // }
  const url = `${FETCH_FJ_AGENTS_URL}${customer}`;
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function deleteFJAgents(agent) {
  const url = `${FETCH_FJ_AGENTS_URL}${agent}`;
  return (dispatch) => {
    return axios({
      method: 'delete',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}


export function fetchPT(customer, type) {
  let url = ``;
  if (type==="Vendor") {
    url = `${FETCH_PRICE_TABLE_URL_VENDOR}${customer}`;
  } else {
    url = `${FETCH_PRICE_TABLE_URL}${customer}`;
  }
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function updatePT(customer, priceArray, type) {
  // let output = [];
  // priceArray.map(r => {
  //   if (r.name) {
  //     output.push(r);
  //   }
  // });
  let output = {fees: priceArray};
  let url = ``;
  if (type==="Vendor") {
    url = `${FETCH_PRICE_TABLE_URL_VENDOR}${customer}`;
  } else {
    url = `${FETCH_PRICE_TABLE_URL}${customer}`;
  }
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/customers_actions.js